{
  "edi": {
    "in": [
      {
        "name": "Movement",
        "value": "MVT",
        "providers": [ 0 ]
      },
      {
        "name": "Inventory",
        "value": "INV",
        "providers": [ 0 ]
      },
      {
        "name": "Expedition",
        "value": "EXP",
        "providers": [ 0 ]
      },
      {
        "name": "Transport",
        "value": "TRA",
        "providers": [ 0 ]
      },
      {
        "name": "Merch",
        "value": "MRI",
        "providers": [ 1 ]
      },
      {
        "name": "Merch 2",
        "value": "MRI2",
        "providers": [ 1 ]
      },
      {
        "name": "Merch statement",
        "value": "MRS",
        "providers": [ 1 ]
      },
      {
        "name": "Rent",
        "value": "RTI",
        "providers": [ 1 ]
      },
      {
        "name": "Rent service",
        "value": "RTM",
        "providers": [ 1 ]
      },
      {
        "name": "Rent transport",
        "value": "RTT",
        "providers": [ 1 ]
      },
      {
        "name": "Rent statement",
        "value": "RTS",
        "providers": [ 1 ]
      },
      {
        "name": "Service",
        "value": "SPI",
        "providers": [ 1 ]
      },
      {
        "name": "Service 2",
        "value": "SPI2",
        "providers": [ 1 ]
      },
      {
        "name": "Service statement",
        "value": "SPS",
        "providers": [ 1 ]
      },
      {
        "name": "Expedition RSW 2",
        "value": "EXW2",
        "providers": [ 0 ]
      },
      {
        "name": "Inventory RSW 2",
        "value": "INW2",
        "providers": [ 0 ]
      },
      {
        "name": "Transport RSW 2",
        "value": "TRW2",
        "providers": [ 0 ]
      },
      {
        "name": "Reception RSW 2",
        "value": "OPW2",
        "providers": [ 0 ]
      },
      {
        "name": "Return Central Status RSW 2",
        "value": "RCW2",
        "providers": [ 0 ]
      },
      {
        "name": "Destruction Status RSW 2",
        "value": "DSW2",
        "providers": [ 0 ]
      },
      {
        "name": "Expedition Assort (PF)",
        "value": "EAS",
        "providers": [ 3 ]
      },
      {
        "name": "Transport Assort (PF)",
        "value": "TAS",
        "providers": [ 3 ]
      },
      {
        "name": "External Order",
        "value": "XTO",
        "providers": [ 3 ]
      },
      {
        "name": "External Picking",
        "value": "XTP",
        "providers": [ 3 ]
      },
      {
        "name": "External Billing",
        "value": "XTB",
        "providers": [ 3 ]
      }
    ],
    "out": [
      {
        "name": "Groupage",
        "value": "GRP",
        "providers": [ 0, 3 ]
      },
      {
        "name": "Order",
        "value": "ORD",
        "providers": [ 0 ]
      },
      {
        "name": "Product",
        "value": "ART",
        "providers": [ 0 ]
      },
      {
        "name": "Merch",
        "value": "MRO",
        "providers": [ 1 ]
      },
      {
        "name": "Merch statement",
        "value": "MSO",
        "providers": [ 1 ]
      },
      {
        "name": "Rent",
        "value": "RTO",
        "providers": [ 1 ]
      },
      {
        "name": "Rent service",
        "value": "RMO",
        "providers": [ 1 ]
      },
      {
        "name": "Service",
        "value": "SPA",
        "providers": [ 1 ]
      },
      {
        "name": "Service statement",
        "value": "SSO",
        "providers": [ 1 ]
      },
      {
        "name": "Order RSW 2",
        "value": "RSW2",
        "providers": [ 0 ]
      },
      {
        "name": "Order RSW Destruction 2",
        "value": "ODW2",
        "providers": [ 0 ]
      },
      {
        "name": "Order RSW Return Central 2",
        "value": "OCW2",
        "providers": [ 0 ]
      },
      {
        "name": "Order RSW Transfer 2",
        "value": "OTW2",
        "providers": [ 0 ]
      },
      {
        "name": "Order Assort (PF)",
        "value": "OAS",
        "providers": [ 3 ]
      }
    ]
  },
  "dde": {
    "in": [
      {
        "name": "DDE Orga",
        "value": "importorga"
      },
      {
        "name": "DDE FDV",
        "value": "importfdv"
      },
      {
        "name": "DDE MAG V2",
        "value": "importmagasinv2"
      },
      {
        "name": "DDE Address V2",
        "value": "importaddressv2"
      },
      {
        "name": "DDE Address Delays",
        "value": "importaddressdelay"
      },
      {
        "name": "DDE Address Visit Rate",
        "value": "importaddressvisitrate"
      },
      {
        "name": "DDE Delivery Location Diffusion",
        "value": "importdeliverylocationdiffusion"
      },
      {
        "name": "DDE Catalog Assort V2",
        "value": "importproductassort"
      },
      {
        "name": "DDE Product Order Container",
        "value": "importproductassortcontainer"
      },
      {
        "name": "DDE Product Promo Container",
        "value": "importproductcontainer"
      },
      {
        "name": "DDE Photos Assort",
        "value": "importphotosassort"
      },
      {
        "name": "DDE Warehouse",
        "value": "importwarehouse"
      },
      {
        "name": "DDE Warehouse Info",
        "value": "importwarehouseinfo"
      },
      {
        "name": "DDE Assort Diffusion V2",
        "value": "importassortdiffusionv2"
      },
      {
        "name": "DDE Channel Diffusion",
        "value": "importchanneldiffusion"
      },
      {
        "name": "DDE Assort Sellin",
        "value": "productaccountsellin"
      },
      {
        "name": "DDE Init Account Segment",
        "value": "initaccountsegment"
      },
      {
        "name": "Create Flashing",
        "value": "createflashing"
      },
      {
        "name": "DDE Catalog Sales",
        "value": "importcatalogue"
      },
      {
        "name": "DDE Photos Sales",
        "value": "importphotos"
      },
      {
        "name": "DDE Catalog Shelves",
        "value": "importproductsshelves"
      },
      {
        "name": "DDE Catalog Categories",
        "value": "importproductscategories"
      },
      {
        "name": "DDE Catalog Organisations",
        "value": "importproductsorganisations"
      },
      {
        "name": "DDE Catalog Roles",
        "value": "importproductsroles"
      },
      {
        "name": "DDE Catalog Order Validation Roles",
        "value": "importproductsordervalidationroles"
      },
      {
        "name": "DDE Catalog Displays",
        "value": "importproductsdisplays"
      },
      {
        "name": "DDE Catalog Order Types",
        "value": "importproductsordertypes"
      },
      {
        "name": "DDE Catalog Services",
        "value": "importproductsproductservices"
      },
      {
        "name": "DDE Catalog Delivery Location Types",
        "value": "productdeliverylocationtypes"
      },
      {
        "name": "DDE Catalog Logistics",
        "value": "importproductslogistic"
      },
      {
        "name": "DDE Import Campaigns",
        "value": "importcampaign"
      },
      {
        "name": "DDE Import Campaigns Offers",
        "value": "importcampaignoffer"
      },
      {
        "name": "DDE Import Delivery Location Contacts",
        "value": "importdeliverylocationcontact"
      }
    ],
    "out": [
      {
        "name": "Export Catalog (?)",
        "value": "exportcatalogue"
      },
      {
        "name": "Export Assort Catalog V2",
        "value": "exportcatalogueassortv2"
      },
      {
        "name": "Export Assort Agreement V2",
        "value": "exportassortagreementv2"
      },
      {
        "name": "Export Assort AgreementBySegment V2",
        "value": "exportassortagreementbysegmentv2"
      },
      {
        "name": "Export Assort Warehouse V2",
        "value": "exportassortwarehousev2"
      },
      {
        "name": "Export Product Statement",
        "value": "exportproductstatements"
      },
      {
        "name": "Export Product Statement Simulated",
        "value": "exportproductstatementssimulated"
      }
    ]
  },
  "sfa": [
    {
      "name": "Import Visites",
      "value": "importappointment"
    },
    {
      "name": "Import segments par magasin complet",
      "value": "importdeliverylocationsegment mode=full"
    },
    {
      "name": "Import segments par magasin différentiel",
      "value": "importdeliverylocationsegment mode=differential"
    },
    {
      "name": "Synchronization DN CRM",
      "value": "productaccountdiffusionssfas"
    },
    {
      "name": "Appliquer objectives KPI",
      "value": "applykpiplanned"
    }
  ],

  "assortiment": [
    {
      "name": "Assortiment",
      "value": "eCOS.Assortiment"
    }
  ],
  "innoDefinitive": [
    {
      "name": "Inno Definitive",
      "value": "eCOS.InnoDefinitive"
    }
  ],
  "specialization": [
    {
      "name": "Spécialisation",
      "value": "eCOS.Specialization"
    }
  ]
}